import {slidbarApi} from '@/api/login';
import router from '@/router';
import layout from '@/layout';

const routerV = {
  namespaced: true,
  state: {
    defaultRouter: []
  },
  mutations: {
    SET_DEFAULT_ROUTER: (state, router) => {
      state.defaultRouter = router;
    }
  },
  actions: {
    async getMenuList({commit}, userId) {
      await slidbarApi({userId}).then((res) => {
        const routerArr = handleRoutes(res.data);
        const addRoutes = [];
        handleAddRoutes(routerArr, addRoutes);
        const detailRoutes = generateDetailRoutes(addRoutes);
        addRoutes.push(...detailRoutes);

        addRoutes.push({
          path: '*',
          redirect: '/'
        });
        router.addRoute({
          path: '/',
          component: layout,
          children: addRoutes
        });
        commit('SET_DEFAULT_ROUTER', routerArr);
      });
    }
  }
};

function generateDetailRoutes(routes, detailRoutes = []) {
  // 配置每个路由需要的子页面类型
  const routeSubPages = {
    '/order': [{type: 'detail', title: '订单详情'}]
  };

  routes.forEach((route) => {
    const subTypes = routeSubPages[route.path];
    if (subTypes && Array.isArray(subTypes)) {
      subTypes.forEach((page) => {
        const subPath = `${route.path}/${page.type}`;
        detailRoutes.push({
          path: subPath,
          component: () => import(`@/pages${route.path}/${page.type}`),
          meta: {
            title: `${page.title}`,
            hidden: true,
            activeMenu: route.path
          }
        });
      });
    }
    if (route.children && route.children.length > 0) {
      generateDetailRoutes(route.children, detailRoutes);
    }
  });
  return detailRoutes;
}

// 处理路由格式
function handleRoutes(routes, routerArr = []) {
  routes.forEach((route) => {
    if (route.meta) {
      routerArr.push({
        id: route.id,
        component: () => import(`@/pages${route.path}`),
        path: route.path,
        meta: route.meta
      });
    }
    if (route.children && route.children.length > 0) {
      routerArr[routerArr.length - 1].children = [];
      handleRoutes(route.children, routerArr[routerArr.length - 1].children);
    }
  });
  return routerArr;
}
// 二次处理路由数据
function handleAddRoutes(routes, routerArr = []) {
  routes.forEach((route) => {
    if (route.children && route.children.length > 0) {
      handleAddRoutes(route.children, routerArr);
    } else {
      routerArr.push({
        path: route.path,
        meta: route.meta,
        component: route.component
      });
    }
  });
}
export default routerV;
